/**
 * Collection catalog — live product search (Pre-order / Album / Merch)
 */
(() => {
  const root = document.querySelector('[data-md-collection]');
  if (!root) return;

  const searchInput = root.querySelector('[data-md-collection-search]');
  if (!searchInput) return;

  const items = [...root.querySelectorAll('[data-md-collection-item]')];
  const countEl = root.querySelector('[data-md-collection-count]');
  const emptyEl = root.querySelector('[data-md-collection-empty]');
  const total = items.length;

  const normalize = (value) =>
    (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9가-힣\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const update = () => {
    const q = normalize(searchInput.value || '');
    let visible = 0;

    items.forEach((item) => {
      const haystack = normalize(item.dataset.search || item.textContent);
      const show = !q || haystack.includes(q);
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (countEl) countEl.textContent = String(q ? visible : total);
    if (emptyEl) emptyEl.hidden = visible > 0;
  };

  searchInput.addEventListener('input', update);
})();
